import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { PAGES } from '../../../../router/routes'
import ciclosManager from '../../../../services/api/ciclos/ciclosManager'
import { CicloPorParceiroForm, Ciclos, IniciarNovoCicloForm, novoCiclo, NovoCicloAutomacao } from '../../../../types/ciclosApiType'
import { ResponsePaginado } from '../../../../types/genericoType'
import { cardExpansivelStyles } from './CardExpansivel.style'
import { CardExpansivelProps } from './CardExpansivel.View'
import { useForm } from 'react-hook-form'
import { ManualApiPayload } from '../../../../types/ciclosApiType'
import automacaoManager from '../../../../services/api/automacao/automacaoManager'

export function cardExpansivelIO({ parceiroComCiclos, pagina }: CardExpansivelProps) {
  const [isCardExpandido, setIsCardExpandido] = useState(false)
  const [carregando, setCarregando] = useState(false)
  const [totalLinhas, setTotalLinhas] = useState(0)
  const [modalAberto, setModalAberto] = useState(false)
  const [modalApiAberto, setModalApiAberto] = useState(false)
  const [isApiGenerating, setIsApiGenerating] = useState(false)
  const [ciclos, setCiclos] = useState<Ciclos[]>([])
  const router = useHistory()

  const { handleSubmit, control } = useForm<{ cicloId?: number }>({
    defaultValues: {
      cicloId: undefined
    }
  })

  const expandirCard = () => {
    setIsCardExpandido((prev) => !prev)
    if (!isCardExpandido) buscarCiclosParceiro({ pageNumber: 1, pageSize: 5, orderBy: 'desc', orderField: 'CicloId' })
  }

  useEffect(() => {
    setIsCardExpandido(false)
  }, [pagina])

  const buscarCicloIdParceiro = (data: { cicloId?: number }) => {
    buscarCiclosParceiro({ pageNumber: 1, pageSize: 5, orderBy: 'desc', orderField: 'CicloId', cicloId: data.cicloId })
  }

  const buscarCiclosParceiro = useCallback(
    (paginacao: CicloPorParceiroForm) => {
      setCarregando(true)
      ciclosManager
        .buscarCicloParceiro(parceiroComCiclos.parceiroId, paginacao)
        .then((response: ResponsePaginado<Ciclos>) => {
          setCiclos(response.itens)
          setTotalLinhas(response.totalItens)
        })
        .catch(() => {
          toast.error(msgConstants.USO_GENERICO.erroBusca)
        })
        .finally(() => {
          setCarregando(false)
        })
    },
    [parceiroComCiclos.parceiroId]
  )

  async function iniciarCiclo(data: IniciarNovoCicloForm) {
    await ciclosManager
      .iniciarCiclo(parceiroComCiclos.parceiroId, data)
      .then((response: novoCiclo) => {
        router.push(PAGES.iniciarCiclo(response.cicloId))
      })
      .catch(() => {
        toast.error(msgConstants.CICLO_FLUXO.erroIniciarCiclo)
      })
  }

  async function iniciarGeracaoDeArquivo(payload: ManualApiPayload) {
    setIsApiGenerating(true)
    try {
      await automacaoManager.gerarArquivoManual(parceiroComCiclos.parceiroId, payload).then((response: NovoCicloAutomacao) => {
        router.push(PAGES.iniciarCiclo(response.dataObject))
      })
      toast.success('Solicitação de geração de arquivo enviada')
      setModalApiAberto(false)
    } catch (error) {
      toast.error('Falha ao solicitar a geração do arquivo.')
    } finally {
      setIsApiGenerating(false)
    }
  }

  return {
    styles: cardExpansivelStyles,
    expandirCard,
    iniciarCiclo,
    isCardExpandido,
    buscarCiclosParceiro,
    ciclos,
    totalLinhas,
    carregando,
    modalAberto,
    setModalAberto,
    modalApiAberto,
    setModalApiAberto,
    isApiGenerating,
    iniciarGeracaoDeArquivo,
    control,
    handleSubmit,
    buscarCicloIdParceiro,
    buscarCicloParceiroEnter: (event: { key: string }) => {
      if (event.key == 'Enter') {
        return handleSubmit(buscarCicloIdParceiro)()
      }
    }
  }
}
export type CardExpansivelIO = ReturnType<typeof cardExpansivelIO>
